<div>
	<span
		class="rounded-sm bg-that-offWhite px-3 py-1 text-xs font-medium leading-10
		leading-4 text-thatBlue-800 shadow-md">
		<slot />
	</span>
</div>
